
function Schedule() {
    return (
      <div></div>
    );
  }
  
  export default Schedule;